import { isEqual } from "lodash";
import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getMethod, SortItemList } from "../../store/actions";
import { SET_FILTER } from "../../store/actions/actionTypes";
import FilterWrapper from "../Filters/FilterWrapper";
import GridContainer from "../GridView/GridContainer";
import MarketPlaceList from "./MarketPlaceList";

const MarketPlace = () => {
  const [gridView, setGridView] = useState(true);
  const [data, setdata] = useState([]);
  const { id } = useParams();
  const dispatch = useDispatch();
  const { marketPlace } = useSelector((state) => state.filters);

  const changeViewType = useCallback(
    (value) => {
      setGridView(value);
    },
    [gridView]
  );
  const filterChangeHandler = useCallback(
    (key, value) => {
      dispatch({
        type: SET_FILTER,
        payload: { marketPlace: { ...marketPlace, [key]: value } },
      });
    },
    [marketPlace]
  );

  const sortItem = useCallback(
    (items, field, sort, time = false, string = false) => {
      let array = SortItemList(items, field, sort, time, string);
      setdata(array);
    }
  );

  //api
  useEffect(() => {
    dispatch(
      getMethod(
        `livemarket`,
        { contract_address: id },
        process.env.REACT_APP_REQUEST_URL
      )
    )
      .then((res) => {
        if (res.isSuccess) {
          setdata(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const filterList = [
    {
      name: "nft_name",
      title: "NFT name",
      type: "select",
      data: ["nft1", "nft2"],
      value: marketPlace.nft_name,
    },
    {
      name: "nft_attribute",
      title: "Attributes",
      type: "select",
      data: ["attribute1", "attribute2"],
      value: marketPlace.nft_attribute,
    },
    {
      name: "nft_owner",
      title: "Original Owner",
      type: "select",
      data: ["owner1", "owner2"],
      value: marketPlace.nft_owner,
    },
  ];

  return (
    <div className="tab-pane" id="tabs-3" role="tabpanel">
      <div className="chart-box bg-white pb-5">
        <FilterWrapper
          title={"Marketplace NFT’s"}
          viewType={gridView}
          changeViewType={changeViewType}
          filterList={filterList}
          view={true}
          onChange={filterChangeHandler}
        />
        {gridView ? (
          <GridContainer list={data} />
        ) : (
          <MarketPlaceList sort={sortItem} list={data} />
        )}
      </div>
    </div>
  );
};

export default React.memo(MarketPlace, isEqual);
